import type { ClientOfferWithPlans, Pages } from '@avalara/types/offers';
import type { OfferState } from '@avalara/types/reducer-states';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: OfferState = {
  provisioningDelayed: false,
  obligationProvisioningStatus: null,
  analyticsProductCategory: '',
  attributionDefaults: {},
  fetchStatus: 'PENDING',
  includesSelectPage: false,
  isPaymentRequired: false,
  offerFlow: null,
  offerName: '',
  orderSummary: { totalText: '' },
  pages: [],
  plans: [],
  termsAndConditions: [],
  thankYouContent: {},
};

const store = createSlice({
  name: 'offer',
  initialState,
  reducers: {
    setCurrentOfferPage: (state, action: PayloadAction<Pages>) => {
      state.currentPage = action.payload;
    },
    setOffer: (state, action: PayloadAction<ClientOfferWithPlans | 'NOT_FOUND' | null>) =>
      action.payload && action.payload !== 'NOT_FOUND'
        ? { ...initialState, includesSelectPage: state.includesSelectPage, ...action.payload, fetchStatus: 'SUCCESS' }
        : { ...initialState, fetchStatus: 'NOT_FOUND' },
    setProvisioningDelayed: (state, action: PayloadAction<boolean>) => {
      state.provisioningDelayed = action.payload;
    },
    setObligationProvisioningStatus: (state, action: PayloadAction<'pending' | 'success' | 'failed' | null>) => {
      state.obligationProvisioningStatus = action.payload;
    },
  },
});

export const { setCurrentOfferPage, setOffer, setProvisioningDelayed, setObligationProvisioningStatus } = store.actions;

export default store;
